<template>
  <div class="footer1-wrapper">
    <div class="footer1">
      <div class="footer-bg-1">
        <div class="footer-bg-p1">全面赋能 打造完整的智慧城市生态</div>
        <div class="footer-bg-p2" @click="handleConsult">立即咨询</div>
      </div>
      <div class="home-page">
        <div class="footer-content">
          <div class="footer-content-item">
            <div class="footer-content-item-title">联系我们</div>
            <div class="footer-content-item-contact">
              <div class="left">
              <div class="footer-content-item-span">
                <div class="footer-content-item-span-img">
                  <img :src="phoneImg" alt="" />
                </div>
                <div class="footer-content-item-span-span">
                  027-87772899（周一至周五 8:30-17:30）
                </div>
              </div>
              <div class="footer-content-item-span">
                <div class="footer-content-item-span-img">
                  <img :src="emailImg" alt="" />
                </div>
                <div class="footer-content-item-span-span">
                  topeak@hubeitopeak.com
                </div>
              </div>
              <div class="footer-content-item-span">
                <div class="footer-content-item-span-img">
                  <img :src="geoImg" alt="" />
                </div>
                <div class="footer-content-item-span-span">
                  武汉市洪山区野芷湖西路16号武汉创意天地3号楼七楼
                </div>
              </div>
            </div>
            <div class="right">
              <div class="footer-content-item-span">
              <div class="footer-content-item-span-qr">
                <el-popover
                  placement="top"
                  trigger="hover"
                  :visible-arrow="false"
                  popper-class="qr-popover"
                >
                  <div class="qr-large">
                    <img :src="wxgzhImg" alt="微信公众号二维码" />
                    <p>扫码关注微信公众号</p>
                  </div>
                  <div slot="reference" class="qr-trigger" style="display: flex;flex-direction: column;align-items: center;">
                    <img :src="wxgzhImg" alt="" />
                    <span>微信公众号</span>
                  </div>
                </el-popover>
              </div>
              <div class="footer-content-item-span-qr">
                <el-popover
                  placement="top"
                  trigger="hover"
                  :visible-arrow="false"
                  popper-class="qr-popover"
                >
                  <div class="qr-large">
                    <img :src="sphImg" alt="视频号二维码" />
                    <p>扫码关注视频号</p>
                  </div>
                  <div slot="reference" class="qr-trigger" style="display: flex;flex-direction: column;align-items: center;">
                    <img :src="sphImg" alt="" />
                    <span>视频号</span>
                  </div>
                </el-popover>
              </div>
            </div>
            </div>
            </div>

          </div>
        </div>
      </div>
      <div class="footer-division"></div>
      <div class="copyright-wrapper">
        <div class="home-page">
          <div class="copyright" v-html="copyrightText" @click="handleCopyrightClick"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Geo from '@/assets/geo.png'
import Email from '@/assets/email.png'
import Phone from '@/assets/phone.png'
import Wxgzh from '@/assets/wxgzh.png'
import Sph from '@/assets/sph.png'
import Hot from '@/assets/hot.png'

export default {
  name: 'Footer2',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clickCount: 0,
      clickTimer: null,
      clickThreshold: 5, // 需要点击5次
      clickTimeout: 2000, // 2秒内完成
      phoneImg: Phone,
      emailImg: Email,
      geoImg: Geo,
      wxgzhImg: Wxgzh,
      sphImg: Sph,
      hotImg: Hot,
      copyrightText: `
        <span>
          <span>
            Copyright © 2019-2026 &nbsp;
            <a href="http://www.hubeitopeak.com">
              湖北泰跃卫星技术发展股份有限公司
            </a>
            &nbsp; 版权所有
          </span>
          <span>
            &nbsp; ICP备案号：
            <a href="https://beian.miit.gov.cn">鄂ICP备19012400号-1</a>
          </span>
        </span>
      `
    }
  },
  methods: {
    handleConsult() {
      // 显示公司电话号码
      this.$alert('公司咨询电话：<br/><strong style="font-size: 18px; color: #1890ff;">027-87772899</strong><br/><br/>工作时间：周一至周五 8:30-17:30', '立即咨询', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '知道了',
        confirmButtonClass: 'consult-btn',
        center: true,
        showClose: false // 隐藏右上角关闭按钮
      })
    },
    handleCopyrightClick() {
      // 清除之前的定时器
      if (this.clickTimer) {
        clearTimeout(this.clickTimer)
      }

      // 增加点击计数
      this.clickCount++

      // 检查是否达到点击阈值
      if (this.clickCount >= this.clickThreshold) {
        // 重置计数器并跳转到登录页面
        this.clickCount = 0
        this.$router.push('/login')
        this.$message.success('已进入后台管理入口')
      } else {
        // 设置新的定时器，2秒后重置计数器
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
        }, this.clickTimeout)
      }
    }
  }
}
</script>

<style scoped>
.footer1-wrapper {
  overflow: hidden;
  position: relative;
  min-height: 360px;
  color: #242934;
}

.footer1 {
  background-color: #f4f7fc;
}

.footer1 .home-page {
  padding: 80px 40px 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

.footer-content-item {
  flex: 1;
  min-width: 0;
}

.footer-content-item-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #1a1a1a;
  letter-spacing: 0.5px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-content-item-title::before {
  content: '';
  width: 4px;
  height: 20px;
  background: linear-gradient(180deg, #1890ff, #40a9ff);
  border-radius: 2px;
  flex-shrink: 0;
}

.footer-content-item-title::after {
  content: '';
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #1890ff, transparent);
  border-radius: 1px;
}
.footer-content-item-contact{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.footer-content-item-span {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 14px;
  white-space: nowrap;
  color: #666;
  transition: all 0.3s ease;
  padding: 6px 0;
  border-radius: 4px;
  position: relative;
}

.footer-content-item-span:hover {
  background: rgba(24, 144, 255, 0.05);
  padding-left: 8px;
}

.footer-content-item-span:hover {
  color: #1890ff;
  transform: translateX(5px);
}

.footer-content-item-span .hot {
  margin-left: 8px;
  width: 32px;
  height: 16px;
  transition: transform 0.3s ease;
}

.footer-content-item-span:hover .hot {
  transform: scale(1.1);
}

.footer-content-item-span-img {
  display: flex;
  align-items: center;
}

.footer-content-item-span-img {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.footer-content-item-span-img img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  transition: all 0.3s ease;
  filter: brightness(0.7);
}

.footer-content-item-span:hover .footer-content-item-span-img img {
  transform: scale(1.1);
  filter: brightness(1);
}

.footer-content-item-span-span {
  flex: 1;
}

.footer-content-item-span-qr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  transition: transform 0.3s ease;
}

.footer-content-item-span-qr:hover {
  transform: translateY(-5px);
}

.footer-content-item-span-qr img {
  width: 120px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.footer-content-item-span-qr:hover img {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
}

.footer-content-item-span-qr span {
  margin-top: 8px;
  font-size: 13px;
  color: #999;
}

.footer-bg-1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) url(@/assets/footer-bg1.png) no-repeat center center / cover;
  background-blend-mode: overlay;
  height: 400px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.footer-bg-1::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.footer-bg-p1 {
  font-size: 48px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
  color: #ffffff;
  position: relative;
  z-index: 2;
  letter-spacing: 1px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.footer-bg-p2 {
  cursor: pointer;
  width: 160px;
  height: 50px;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  border-radius: 6px;
  font-size: 18px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  box-shadow: 0 4px 20px rgba(24, 144, 255, 0.4);
}

.footer-bg-p2:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 8px 30px rgba(24, 144, 255, 0.5);
}

.footer-division {
  width: 100vw;
  height: 1px;
  background: #e3e6ec;
}

.copyright-wrapper {
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.copyright-wrapper .home-page {
  font-size: 14px;
  padding: 0 40px;
  overflow: hidden;
}

.copyright {
  text-align: center;
  margin: 40px 0;
  color: #666;
  line-height: 1.6;
  font-weight: 400;
}

.copyright a {
  color: #242934;
  text-decoration: none;
}

.copyright a:hover {
  color: #1890ff;
}

@media screen and (max-width: 767px) {
  .footer1 .home-page {
    padding: 60px 20px 30px;
  }

  .footer-content {
    flex-direction: column;
    gap: 30px;
  }

  .footer-content-item {
    margin-bottom: 0;
  }

  .footer-content-item-title {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .footer-content-item-span {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .copyright-wrapper .home-page {
    padding: 0;
  }
  
  .copyright {
    font-size: 12px;
  }
  
  .copyright span {
    width: 90%;
    display: block;
  }
}
</style>